import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MobileBar } from "@/components/MobileBar";
import { CookieBanner } from "@/components/CookieBanner";

export const SiteLayout = () => (
  <div className="flex min-h-screen flex-col bg-[#090D10]">
    <Navbar />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <MobileBar />
    <CookieBanner />
  </div>
);
